import { apiClient } from './client';

/**
 * 오늘 근태 — **전사 한 장** (인사 홈, 시안 A1).
 *
 * 서버: `apps/chat-server/src/modules/hr/attendance-today.routes.ts`.
 *
 * ★★ **숫자만 온다.** 이름도 시각도 없다 — 홈은 «몇 명인가» 만 필요하고, 누가 언제인지는
 *    «근태 현황» 이 권한을 따로 물어서 보여 준다.
 * ★ «팀 근태» 는 **한 번에 한 팀**이라 전사 도넛을 못 그린다. 그래서 이 라우트가 따로 있다.
 * ★ 주소가 `company-today` 인 까닭 — `/hr/attendance/today` 는 **내 오늘 기록**이 이미 쓴다.
 * ★ 옛 서버에는 없다(404) · 전사를 못 보는 사람은 403 — 부르는 쪽이 실패를 삼킨다.
 */
export interface AttendanceTodayDto {
  date: string;
  total: number;
  /** 찍고 일하는 중. */
  working: number;
  /** 퇴근까지 찍음. */
  off: number;
  /** 출장 · 외근(간주 출근). */
  trip: number;
  onLeave: number;
  absent: number;
  /** 나온 사람 = working + off + trip. 휴가와 미출근만 뺀다. */
  present: number;
  /** 나온 비율 0~100(정수). */
  rate: number;
  /** 오늘 지각. */
  late: number;
  /** 어제 이전에 출근만 있고 퇴근이 없는 기록(최근 7일). */
  openRecords: number;
  tzOffsetMinutes: number;
}

export async function fetchAttendanceToday(): Promise<AttendanceTodayDto> {
  const { data } = await apiClient.get<AttendanceTodayDto>('/hr/attendance/company-today');
  return data;
}
